import { HttpResponse, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../utils/common.constants';

@Injectable()
export class FileUploadService {

    constructor(private http: HttpClient) { }
  
    upload(file): Observable<any> {
       const req = new HttpRequest('POST', CommonConstants.env+"api/master/upload", file, {
         responseType: 'json'
       });
       return this.http.request(req);
     }

     saveAttachment(saveData){
      return this.http.post(CommonConstants.env +'api/patient/document/create', saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
    }

    getMedicalDocuments(type, medfId){
      return this.http.get(CommonConstants.env +'api/patient/document/'+type+'/'+medfId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
    }

    
  errorHandler(error: any): void {
    throwError(error);
  };
  /*   getFiles(): Observable<any> {
      return this.http.get(`${this.baseUrl}/files`);
    } */
  }
